import AppErrorBoundary from '../AppErrorBoundary';
import MonthViewCalendars from '../Calendars/FlightsCalendars/MonthViewCalendars';
import Filter from '../Filter';

import './MonthViewCalendarPanel.scss';

const MonthViewCalendarPanel = ({ isReturn }: { isReturn: boolean }) => (
  <div>
    <AppErrorBoundary location="tabbed-calendars">
      <div className="month-view-calendar-panel--two-cal-layout">
        <div className="month-view-calendar-panel-calendar">
          <AppErrorBoundary location="tabbed-calendars">
            <Filter className="month-view-filters" showCheckBox />
          </AppErrorBoundary>
          <MonthViewCalendars isReturn={isReturn} />
        </div>
      </div>
    </AppErrorBoundary>
  </div>
);

export default MonthViewCalendarPanel;
